import { z } from 'zod';

export const orderProblemTypeSchema = z.enum(['accident', 'theft', 'items_damage', 'other']);

export const orderProblemSchema = z.object({
  /** a description of the problem */
  description: z.coerce.string().optional(),
  /** type of the problem */
  type: orderProblemTypeSchema,
});
